<!-- Old Metal Details -->
<div class="w-full bg-fff1f8 rounded-lg p-2 relative">
  <!-- Loading state -->
  <div *ngIf="isLoading"
    class="absolute inset-0 bg-white bg-opacity-50 z-10 flex items-center justify-center rounded-lg">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-8f014d"></div>
  </div>

  <!-- title and total amount -->
  <div (click)="toggleAccordion('oldmetal')"
    class="cursor-pointer pb-2 border-b border-8f014d flex items-center justify-between gap-2">
    <div class="flex items-center justify-start gap-4">
      <p class="text-sm sm:text-base xl:text-lg font-semibold text-8f014d">{{ oldmetalSummary.title }}</p>
      <p class="w-5 h-5 bg-white rounded-full flex items-center justify-center">
        <svg [class.rotate-180]="accordionState.oldmetal" class="transition-transform duration-300" viewBox="0 0 20 20"
          fill="none" xmlns="http://www.w3.org/2000/svg"
          class="fill-8a8a8a group-hover:fill-0d5bab size-5 transition-transform duration-300">
          <path d="M5.83398 8.3335L10.0007 12.5002L14.1673 8.3335H5.83398Z"></path>
        </svg>
      </p>
    </div>
    <p class="text-sm sm:text-base lg:text-lg font-semibold text-8f014d">{{ oldmetalSummary.total | number:'1.2-2' }}g
    </p>
  </div>
  <!-- scrollable area -->
  <div class="overflow-x-auto w-full text-sm lg:text-base flex flex-col gap-3 mt-2">
    <div *ngFor="let trans of transactions" class="flex items-center gap-3 w-full">
      <div *ngFor="let chip of getChips(trans)"
        class="bg-white px-2 py-1.5 rounded-md w-max shadow-sm border border-f3b1ff">
        <p class="flex items-center gap-2 w-max text-777 font-medium">
          <span class="text-686868">{{ chip.label }}</span>|
          <span class="text-1c1c1c">{{ chip.value }}</span>
        </p>
      </div>
    </div>
    <div *ngIf="transactions.length === 0 && !isLoading" class="text-center py-4 text-8a8a8a italic">
      No metal transactions found for the selected period.
    </div>
  </div>
  <!-- Amount Table -->
  <div class="transition-all duration-300 ease-in-out overflow-hidden" [class.max-h-0]="!accordionState.oldmetal"
    [class.max-h-[2000px]]="accordionState.oldmetal">
    <div class="mt-2 overflow-x-auto w-full">
      <table class="daybook-table w-full overflow-hidden">
        <thead class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-semibold">
          <tr class="bg-d9d9d9">
            <th></th>
            <th class="text-bb0000 whitespace-nowrap uppercase">Received (Weight)</th>
            <th colspan="2" class="text-018f37 whitespace-nowrap uppercase">Due / Converted</th>
            <th></th>
          </tr>
          <tr class="bg-f3b1ff">
            <th></th>
            <th>METAL REC.</th>
            <th>METAL UDHAR</th>
            <th>METAL CONV.</th>
            <th>TOTAL SALES</th>
          </tr>
        </thead>
        <tbody class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-medium">
          <tr>
            <td class="text-018f37 whitespace-nowrap uppercase">Weight In :</td>
            <td class="text-018f37">{{ summary.amount_in.cash | number:'1.2-2' }}</td>
            <td class="text-018f37">{{ summary.amount_in.card | number:'1.2-2' }}</td>
            <td class="text-018f37">{{ summary.amount_in.online | number:'1.2-2' }}</td>
            <td class="text-018f37 font-bold">{{ summary.amount_in.total | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-bb0000 whitespace-nowrap uppercase">Weight Out :</td>
            <td class="text-bb0000">0.00</td>
            <td class="text-bb0000">0.00</td>
            <td class="text-bb0000">0.00</td>
            <td class="text-bb0000 font-bold">0.00</td>
          </tr>
          <tr>
            <td class="text-bb0000 whitespace-nowrap uppercase">Today Total :</td>
            <td [class.text-018f37]="summary.amount_in.cash >= 0" [class.text-bb0000]="summary.amount_in.cash < 0">
              {{ summary.amount_in.cash | number:'1.2-2' }}
            </td>
            <td [class.text-018f37]="summary.amount_in.card >= 0" [class.text-bb0000]="summary.amount_in.card < 0">
              {{ summary.amount_in.card | number:'1.2-2' }}
            </td>
            <td [class.text-018f37]="summary.amount_in.online >= 0" [class.text-bb0000]="summary.amount_in.online < 0">
              {{ summary.amount_in.online | number:'1.2-2' }}
            </td>
            <td [class.text-018f37]="summary.amount_in.total >= 0" [class.text-bb0000]="summary.amount_in.total < 0"
              class="font-bold">
              {{ summary.amount_in.total | number:'1.2-2' }}
            </td>
          </tr>
        </tbody>
        <tfoot class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-semibold">
          <tr class="bg-d9d9d9">
            <td class="text-black whitespace-nowrap uppercase">Final Weight Total :</td>
            <td colspan="3"></td>
            <td class="text-black font-bold">{{ summary.amount_in.total | number:'1.2-2' }}g</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>